import CSS from 'csstype';
import React from 'react';

import {
  ActivityIcon,
  AddIcon,
  AIIcon,
  AlertIcon,
  AllDoneIcon,
  ArrowIcon,
  ArrowUpIcon,
  AvailableIcon,
  BiddersIcon,
  BoxSearchIcon,
  CalendarIcon,
  CaretIcon,
  CastIcon,
  ChannelsIcon,
  Checkmark2Icon,
  CheckmarkPlainIcon,
  CirclePlayIcon,
  ClockIcon,
  CloseIcon,
  CodeIcon,
  CollapseIcon,
  ColumnsIcon,
  CompassIcon,
  CopyIcon,
  CtuIcon,
  CubeIcon,
  CustomizeIcon,
  DeleteIcon,
  DistributionIcon,
  DownloadIcon,
  EditIcon,
  EmailIcon,
  ExpandIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FilterIcon,
  FlagIcon,
  FlameIcon,
  FlashIcon,
  FunnelIcon,
  GlobeIcon,
  HamburgerIcon,
  HandshakeIcon,
  HeartIcon,
  ImageIcon,
  InfoIcon,
  InfoStaticIcon,
  InventoryRulesIcon,
  LayersIcon,
  LightBulbIcon,
  LinkIcon,
  LoaderIcon,
  LogInIcon,
  ManualOverrideIcon,
  MessageIcon,
  MonitorIcon,
  PaperPlaneIcon,
  PersonesIcon,
  PillDataIcon,
  PillStatusIcon,
  PlayIcon,
  PresetIcon,
  PriceTagIcon,
  RadioIcon,
  RefreshIcon,
  RepeatIcon,
  SafetyIcon,
  SaveIcon,
  ScheduleIcon,
  SendIcon,
  SettingsIcon,
  ShakeIcon,
  ShoppingIcon,
  ShuffleIcon,
  SparkleIcon,
  SuccessCheckMarkIcon,
  SwapIcon,
  SyncIcon,
  TimerIcon,
  TrendUpIcon,
  UmbrellaIcon,
  UnavailableIcon,
  UndoIcon,
  UnlockIcon,
  UnreviewedIcon,
  UploadIcon,
  VectorIcon,
  VennIcon,
} from '~/src/dash/components/icons/IconV2/icons';
import { fontColorsDefault } from '~/src/dash/components/layout/common';

interface IIconV2Props {
  className?: string;
  color?: string;
  large?: boolean;
  name: string;
  small?: boolean;
  style?: CSS.Properties;
}

export const IconV2 = ({
  className = '',
  color = fontColorsDefault.base,
  large,
  name,
  small,
  style,
}: IIconV2Props) => {
  // keep this alphabetized
  switch (name) {
    case 'activity':
      return (
        <ActivityIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'add':
      return (
        <AddIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'ai-icon':
      return <AIIcon small={small} large={large} className={className} color={color} />;

    case 'alert':
      return (
        <AlertIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'all-done':
      return (
        <AllDoneIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'arrow':
      return (
        <ArrowIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'arrow-up':
      return (
        <ArrowUpIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'available':
      return (
        <AvailableIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'bidders':
      return (
        <BiddersIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'boxSearch':
      return <BoxSearchIcon color={color} className={className} />;

    case 'caret':
      return (
        <CaretIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'cast':
      return (
        <CastIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'clock':
      return (
        <ClockIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'calendar':
      return (
        <CalendarIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'channels':
      return (
        <ChannelsIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'checkmark-plain':
      return (
        <CheckmarkPlainIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'checkmark-2':
      return (
        <Checkmark2Icon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'circle-play':
      return (
        <CirclePlayIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'close':
      return (
        <CloseIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'code':
      return (
        <CodeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'collapse':
      return (
        <CollapseIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'columns':
      return (
        <ColumnsIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'compass':
      return (
        <CompassIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'copy':
      return (
        <CopyIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'ctu':
      return <CtuIcon small={small} large={large} className={className} color={color} />;

    case 'cube':
      return (
        <CubeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'customize':
      return (
        <CustomizeIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'delete':
      return (
        <DeleteIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'download':
      return (
        <DownloadIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'edit':
      return (
        <EditIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'distribution':
      return <DistributionIcon color={color} className={className} />;

    case 'email':
      return (
        <EmailIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'expand':
      return (
        <ExpandIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'externalLink':
      return (
        <ExternalLinkIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'eye':
      return (
        <EyeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'eyeoff':
      return (
        <EyeOffIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'filter':
      return (
        <FilterIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'flag':
      return (
        <FlagIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'flame':
      return (
        <FlameIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'flash':
      return (
        <FlashIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'funnel':
      return (
        <FunnelIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'globe':
      return (
        <GlobeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'handshake':
      return (
        <HandshakeIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'hamburger':
      return (
        <HamburgerIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'heart':
      return (
        <HeartIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'info':
      return (
        <InfoIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'info-static':
      return (
        <InfoStaticIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'image':
      return (
        <ImageIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'inventory-rules':
      return (
        <InventoryRulesIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'layers':
      return (
        <LayersIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'light-bulb':
      return (
        <LightBulbIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'link':
      return (
        <LinkIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'loader':
      return (
        <LoaderIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'log-in':
      return (
        <LogInIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'manual-override':
      return <ManualOverrideIcon small={small} large={large} className={className} color={color} />;

    case 'message':
      return (
        <MessageIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'monitor':
      return (
        <MonitorIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'paper-plane':
      return (
        <PaperPlaneIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'persones':
      return (
        <PersonesIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'pill-data':
      return (
        <PillDataIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'pill-status':
      return <PillStatusIcon color={color} style={style} className={className} />;

    case 'play':
      return (
        <PlayIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'price-tag':
      return (
        <PriceTagIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'preset':
      return (
        <PresetIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'radio':
      return (
        <RadioIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'refresh':
      return (
        <RefreshIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'repeat':
      return (
        <RepeatIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'safety':
      return (
        <SafetyIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'save':
      return (
        <SaveIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'schedule':
      return (
        <ScheduleIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'save':
      return (
        <SaveIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'send':
      return (
        <SendIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'settings':
      return (
        <SettingsIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'shake':
      return (
        <ShakeIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'shopping':
      return (
        <ShoppingIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'shuffle':
      return (
        <ShuffleIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'sparkle':
      return (
        <SparkleIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'success-check-mark':
      return (
        <SuccessCheckMarkIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'sync':
      return (
        <SyncIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'swap':
      return (
        <SwapIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'timer':
      return (
        <TimerIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'trend-up':
      return (
        <TrendUpIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'umbrella':
      return (
        <UmbrellaIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'unavailable':
      return (
        <UnavailableIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'undo':
      return (
        <UndoIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'unlock':
      return (
        <UnlockIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'unreviewed':
      return (
        <UnreviewedIcon
          small={small}
          large={large}
          color={color}
          style={style}
          className={className}
        />
      );

    case 'upload':
      return <UploadIcon color={color} small={small} style={style} className={className} />;

    case 'vector':
      return (
        <VectorIcon small={small} large={large} color={color} style={style} className={className} />
      );

    case 'venn':
      return (
        <VennIcon small={small} large={large} color={color} style={style} className={className} />
      );

    default:
      return <div />;
  }
};
